import React, { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { useGLTF, Center } from '@react-three/drei';

export function ProductModel({
  path,
  autoRotate = true,
  rotationSpeed = 0.4,
  paused = false,
  position = [0, 0, 0],
  scale = 1,
  groupRef,
}) {
  const { scene } = useGLTF(path);
  const internalRef = useRef();
  const ref = groupRef || internalRef;

  useFrame((_, delta) => {
    if (autoRotate && !paused && ref.current) {
      ref.current.rotation.y -= delta * rotationSpeed;
    }
  });

  return (
    <group ref={ref} position={position} scale={scale}>
      <Center>
        <primitive object={scene} />
      </Center>
    </group>
  );
}